import { MatDialogRef } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from '../../../../../i18n/en.json';
import spanish from '../../../../../i18n/es.json';
import portuguese from '../../../../../i18n/pt.json';
var FormDetailsComponent = /** @class */ (function () {
    function FormDetailsComponent(data, matDialogRef, fuseTranslationLoaderService) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.formTitle = data.formTitle;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.questionAnswers = data.questionAnswers;
    }
    FormDetailsComponent.prototype.isChecked = function (answer, option) {
        if (!answer) {
            return false;
        }
        var answers = answer.split('&');
        return answers.includes(option);
    };
    FormDetailsComponent.prototype.splitPicturesUrl = function (answer) {
        if (!answer) {
            return [];
        }
        return answer.split('&');
    };
    return FormDetailsComponent;
}());
export { FormDetailsComponent };
